// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2439ca83] .field{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[data-v-2439ca83] .label{width:191px;font-weight:700}", ""]);
// Exports
module.exports = exports;
